import { Card, Radio, Row, Space, Typography, message } from "antd";
import { useEffect, useState } from "react";
import HTTPClient from "../../../utils/HTTPClient";
import { useTranslation } from "react-i18next";

const Wordpress = ({ appName, app, getData }) => {
    const [availableDomains, setAvailableDomains] = useState([]);
    const { t } = useTranslation();

    useEffect(() => {
        const appDomains = app?.domains || [];
        setAvailableDomains([app?.k8s_ingress?.url, ...appDomains.map((d) => d.domain)]);
    }, [app]);

    const change_main_domain = (domain) => {
        HTTPClient.post("/appcustomizations/wordpress/change_main_domain", { appName, domain })
            .then((res) => {
                getData();
                message.success(t("dettaglio_app.wordpress.success"));
            })
            .catch((e) => {
                message.error(t("dettaglio_app.wordpress.error"));
            });
    };

    return (
        <Card title="Dominio principale" style={{ width: "100%", marginTop: "15px" }}>
            <Row style={{ width: "100%", marginTop: "10px" }}>
                <Typography.Text>{t("dettaglio_app.wordpress.info")}</Typography.Text>
            </Row>
            <Row style={{ width: "100%", marginTop: "10px" }}>
                <Radio.Group
                    onChange={(e) => change_main_domain(e.target.value)}
                    value={app?.customizations?.main_domain || app?.k8s_ingress?.url}>
                    <Space direction="vertical">
                        {availableDomains.map((d) => {
                            return <Radio value={d}>{d}</Radio>;
                        })}
                    </Space>
                </Radio.Group>
            </Row>
        </Card>
    );
};

export { Wordpress };
